/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

if (n === 1)
    return 1;
return 5;
}

export default ["st",[["AM","PM"],u,["Hoseng","Thapama"]],[["AM","PM"]],[["S","M","T","W","T","F","S"],["Son","Mma","Bed","Rar","Ne","Hla","Moq"],["Sontaha","Mantaha","Labobedi","Laboraro","Labone","Labohlano","Moqebelo"],["Son","Mma","Bed","Rar","Ne","Hla","Moq"]],u,[["1","2","3","4","5","6","7","8","9","10","11","12"],["Phe","Kol","Ube","Mme","Mot","Jan","Upu","Pha","Leo","Mph","Pun","Tsh"],["Pherekgong","Hlakola","Hlakubele","Mmesa","Motsheanong","Phupjane","Phupu","Phato","Lwetse","Mphalane","Pudungwana","Tshitwe"]],u,[["BCE","CE"]],0,[6,0],["y-MM-dd","y MMM d","y MMMM d","y MMMM d, EEEE"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤#,##0.00","#E0"],"ZAR","R",u,{"JPY":["JP¥","¥"],"USD":["US$","$"],"ZAR":["R"]},"ltr", plural];
